var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.19a.167.167 0 00-.187-.166.167.167 0 00-.085.036C11.436 12.111 9 12.667 6.666 12.667c-2.333 0-4.77-.556-6.062-1.607a.166.166 0 00-.271.13v1.143C.333 13.807 3.169 15 6.666 15 10.164 15 13 13.807 13 12.333V11.19z",
    fill: "#83ACD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.333 9.333C.333 10.807 3.169 12 6.666 12 10.164 12 13 10.807 13 9.333V8.19a.167.167 0 00-.187-.165.166.166 0 00-.085.036C11.436 9.111 9 9.667 6.666 9.667c-2.333 0-4.77-.556-6.062-1.607a.166.166 0 00-.271.13v1.143z",
    fill: "#83ACD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 6.667c-2.333 0-4.77-.556-6.062-1.608a.166.166 0 00-.271.13v1.144C.333 7.807 3.169 9 6.666 9 10.164 9 13 7.807 13 6.333V5.19a.167.167 0 00-.272-.128C11.436 6.112 9 6.667 6.666 6.667z",
    fill: "#83ACD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 6C10.164 6 13 4.806 13 3.333 13 1.861 10.164.667 6.666.667 3.17.667.333 1.86.333 3.333.333 4.806 3.169 6 6.666 6z",
    fill: "#83ACD4"
  })));
}
export default SvgDatabase2;